/* -------------------------------------------------------------------------- *
 * International Fields for User Registration *
 * -------------------------------------------------------------------------- */

let country_fields_arr;
let cdn_inputs_arr;
let int_inputs_arr;

let country_select;
let country;

function swapFields() {
    // Check if country has changed
    if (country_select.value !== country) {
        // Toggle the fields
        country_fields_arr.forEach((el) => {
            el.classList.toggle('is-hidden');
        });

        if (country_select.value === 'canada') {
            // Clear the international inputs
            int_inputs_arr.forEach((el) => {
                el.value = '';
                el.removeAttribute('required');
            });

            // Make the Canadian fields required
            cdn_inputs_arr.forEach((el) => {
                el.setAttribute('required', '');
            });
        } else {
            // Clear the Canadian inputs
            cdn_inputs_arr.forEach((el) => {
                el.value = '';
                el.removeAttribute('required');
            });

            // Make the international fields required
            int_inputs_arr.forEach((el) => {
                el.setAttribute('required', '');
            });
        }

        country = country_select.value;
    }
}

/* ------------- *
 * Module Export *
 * ------------- */

const InternationalFields = {
    init() {
        // Parent elements to show and hide based on country
        const country_fields = document.querySelectorAll('.js-countryField');
        country_fields_arr = Array.from(country_fields);

        // Inputs to be reset on country switch
        const cdn_inputs = document.querySelectorAll('.js-canadianInput');
        const int_inputs = document.querySelectorAll('.js-internationalInput');
        cdn_inputs_arr = Array.from(cdn_inputs);
        int_inputs_arr = Array.from(int_inputs);

        // Select dropdown for country 'canada/other'
        country_select = document.querySelector('.js-countrySelect');
        country = country_select.value;

        country_select.addEventListener('change', swapFields);
    },
};

export default InternationalFields;
